import { Chip, type SxProps, type Theme } from '@mui/material';
import { appPalette } from '../../theme/palette';
import { calendarSnapshotChipTypography } from './CalendarSnapshotChip';

interface CalendarTypeChipProps {
  name: string;
  backgroundColor?: string | null;
  sx?: SxProps<Theme>;
}

function getTypeChipBackground(backgroundColor?: string | null) {
  if (backgroundColor === 'Red') {
    return appPalette.type.reactive;
  }

  if (backgroundColor === 'Green') {
    return appPalette.type.proactive;
  }

  return undefined;
}

function getTypeChipTextColor(backgroundColor?: string | null) {
  if (backgroundColor === 'Red') {
    return appPalette.type.reactiveText;
  }

  if (backgroundColor === 'Green') {
    return appPalette.type.proactiveText;
  }

  return undefined;
}

export default function CalendarTypeChip({ name, backgroundColor, sx }: Readonly<CalendarTypeChipProps>) {
  return (
    <Chip
      label={name}
      variant="filled"
      sx={[
        {
          backgroundColor: getTypeChipBackground(backgroundColor),
          '&.MuiChip-root': {
            border: '0',
            borderRadius: '10px',
            outline: '0',
            boxShadow: 'none',
            backgroundImage: 'none',
            height: '26px',
          },
          '& .MuiChip-label': {
            ...calendarSnapshotChipTypography,
            fontSize: '11px',
            px: 1.1,
            py: 0,
            color: getTypeChipTextColor(backgroundColor),
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
